/* eslint-disable no-useless-escape */
/* eslint-disable no-redeclare */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import Down from "../Icons/Down";
import Up from "../Icons/Up";
import clsx from 'clsx';
import { Image } from "antd";
import { TextField, TableRow, TableCell, Popover, Typography, Tooltip, IconButton } from '@mui/material';
import customStyles from "../../../../assets/styles/customStyles";
import FieldPrimaryCard from "../Card/FieldPrimaryCard";
import PaginationTable from "../PaginationTable";
import PopupState, { bindPopover, bindFocus } from 'material-ui-popup-state';
import infoMarkIcon from "../../../../assets/images/icon_actions/infoMark.svg";
import { Link, NavLink } from "react-router-dom";
import usePrevious from "../Previous";
import { prevInputFocus } from "../../../../helpers/utilities.js";
import { toast } from 'react-toastify';
import ResetIcon from "../../../../assets/images/icon_actions/ResetIcon.png";

export const AutoCompleteComponent = React.memo(React.forwardRef((props, ref) => {
    const { parentError, name, heads, details,
        onChange, customLink, searchType, searchLength = 2, notEmpty,
        onChangeText, join, id, setRef, orginPosVet, orginPosHor,
        infoMark, variant, parentValue, customClasses, disabled, position, customLabel, placeholder } = props;
    // const [visible, setVisible] = useState(false);
    const [search, setSearch] = useState('');
    const [error, setError] = useState(false);
    const [textValue, setTextValue] = useState('');
    const [width, setWidth] = useState(0);
    const parentRef = useRef('');
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(500);
    const [rowsSelected, setRowsSelected] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const classes = customStyles();

    useEffect(() => {
        setError(parentError || false);
    }, [parentError]);

    const selecteDOnTop = (details) => {
        if (details.length > 0 && parentValue[heads[0].key]) {
            let a = details.filter((el) => { return el[heads[0].key] === parentValue[heads[0].key] });
            let arr = [...a, ...details];
            let uniqueArr = [...new Set(arr)];
            return uniqueArr;
        }
        return [];
    }

    useEffect(() => {
        setData(parentValue[heads[0].key] ? selecteDOnTop(details) : details);
        setWidth(parentRef.current.offsetWidth + 14);
        setTextValue(parentValue[heads[0].key] ? (heads[0].relation ? parentValue[heads[0].key][heads[0].relation] : parentValue[heads[0].key]) : '');
    }, [parentValue[heads[0].key]]);


    useEffect(() => {
        if (rowsSelected) {
            let index = -1;
            document.onkeydown = function (e) {
                var tableId = document.getElementById(position === 'top' ? 'demo-product-top' : 'demo-product-bottom');
                if (tableId) {
                    var tBody = tableId.getElementsByTagName('tbody')[0];
                    var tableRow = tBody.getElementsByTagName('tr');
                    if (e.keyCode === 40) {
                        if (parseInt(index) >= parseInt(tableRow.length) - 1) {
                            return true;
                        }
                        index++;
                        for (var t = 0; t < tableRow.length; t++) {
                            if (tableRow[t] && tableRow[index]) {
                                tableRow[t].classList.remove(classes.selectedRowHover);
                            }
                        }
                        if (tableRow.length > 0 && tableRow[index]) {
                            tableRow[index].classList.add(classes.selectedRowHover);
                            setTextValue(tableRow[index].getElementsByTagName('td')[0]?.textContent || '');
                            tableRow[index].scrollIntoView({ behavior: 'smooth', block: 'end' });
                        }
                    }

                    if (e.keyCode === 38) {
                        if (index === 0) {
                            return true;
                        }
                        index--;
                        for (var t = 0; t < tableRow.length; t++) {
                            if (tableRow[t] && tableRow[index]) {
                                tableRow[t].classList.remove(classes.selectedRowHover);
                            }
                        }

                        if (tableRow.length > 0 && tableRow[index]) {
                            tableRow[index].classList.add(classes.selectedRowHover);
                            setTextValue(tableRow[index].getElementsByTagName('td')[0]?.textContent || '');
                            tableRow[index].scrollIntoView({ behavior: 'smooth', block: 'end' });
                        }
                    }



                    if (e.shiftKey && e.keyCode === 9) {
                        //shift was down when tab was pressed
                        e.preventDefault();
                        prevInputFocus(e)
                    }

                    if (e.keyCode === 46 || e.keyCode === 8) {
                        setRowsSelected(false);
                    }

                    if (!e.shiftKey && e.keyCode === 9) {
                        if (tableRow[index === -1 ? 0 : index]) {
                            e.preventDefault();
                            tableRow[index === -1 ? 0 : index]?.click();
                            if (parentRef?.current?.closest('.MuiInputBase-root')) {
                                parentRef?.current?.closest('.MuiInputBase-root').classList.remove('Mui-focused')
                            }
                        }
                    }

                    if (e.keyCode === 27) {
                        parentRef.current.blur();
                    }
                }
            }
        }
    }, [rowsSelected]);

    useEffect(() => {
        setData(parentValue[heads[0].key] ? selecteDOnTop(details) : details);
    }, [details]);

    useEffect(() => {
        if (setRef && parentRef) {
            setRef(parentRef);
        }
    }, [setRef]);


    const handleClick = (data, popupState) => {
        onChange(data);
        setError(false);
        if (parentValue[heads[0]?.key]) {
            setTextValue(data[heads[0].key] ? (heads[0].relation ? data[heads[0].key][heads[0].relation] : data[heads[0].key]) : parentValue[heads[0].key]);
        }
        popupState.close();
    }

    const handleOnChange = (value, notEmpty = false) => {
        if (value === '' && notEmpty) {
            return true;
        }
        if (value === '') {
            onChange({
                id: ''
            });
            setError(parentError);
        } else {
            setError(false);
        }
        setTextValue(value);
        if (searchType) {
            setSearch(value);
        } else {
            try {
                handleSearchClick(value);
            } catch (err) {
                toast.dismiss();
                toast.error(err?.message || 'Something went wrong');
            }
        }
        if (onChangeText) {
            onChangeText(value);
        }
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > searchLength && prevSearch !== search)
            || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }

            if (search === '') {
                searchType(search);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    searchType(search);
                }, 500);
            }
        }
    }, [search]);

    const handleSearchClick = (s) => {
        let d = '';
        let search = s.replace(/[\|&;\$%@"<>^*\(\)\+,]/g, "").replace(new RegExp("\\\\", "g"), "\\\\");
        let seDetails = details;
        if (search !== '' && search.length > 2) {
            d = seDetails && seDetails?.filter((el) => {
                return (heads.length > 0 && el[heads[0]['key']]?.length && el[heads[0]['key']]?.match(new RegExp(search, "i")))
                    || (heads.length > 1 && el[heads[1]['key']]?.length &&
                        (heads[1]?.relation === undefined ?
                            (el[heads[1]['key']] && (heads[1]['key'] === 'level' ? ("level " + el[heads[1]['key']] + "").match(new RegExp(search, "i")) :
                                el[heads[1]['key']] && el[heads[1]['key']]?.match(new RegExp(search, "i")))) :
                            el[heads[1]['key']] && el[heads[1]['key']][heads[1]?.relation] && el[heads[1]['key']][heads[1].relation].match(new RegExp(search, "i"))))
                    || (heads.length > 2 && el[heads[2]['key']]?.length &&
                        (heads[2].relation === undefined ?
                            (el[heads[2]['key']] && el[heads[2]['key']].match(new RegExp(search, "i"))) : el[heads[2]['key']] && el[heads[2]['key']][heads[2].relation].match(new RegExp(search, "i"))))
            });
        } else {
            d = details;
        }
        setPage(0);
        setData(d);
        setRowsSelected(true);
    }

    const shouldBlur = (e) => {
        if (e.keyCode === 9) {
            //setVisible(false);
        }
        if (e.keyCode === 40) {
            parentRef.current.blur();
            parentRef.current.focus();
        }
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        parentRef.current.focus();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        parentRef.current.focus();
    };

    const handlePopState = (d) => {
        setRowsSelected(d);
    }

    const handleClear = (popupState) => {
        onChange({
            id: ''
        });
        setError(false);
        popupState.close();
        setTextValue('');
    }

    return (
        <PopupState variant="popover" popupId={position === 'top' ? 'demo-product-top' : 'demo-product-bottom'}>
            {(popupState) => (
                <div key={name} className={clsx(classes.customAutoComplete, customClasses, { [classes.bottomPosition]: position === 'bottom' })}>
                    {/* {
                        popupState.isOpen ? handlePopState(popupState.isOpen) : handlePopState(false)
                    } */}
                    {
                        name && name !== '' && infoMark && <Typography variant={'subtitle1'} style={{ lineHeight: 1 }}
                            className={clsx(classes.customAutoLabel, classes.textAlignRight, 'MuiInputLabel-shrink', classes.fonSize13)}>
                            {
                                infoMark &&
                                <Tooltip
                                    classes={{ popper: classes.customToolTip }}
                                    title={infoMark} arrow placement="top" className={classes.tooltip}>
                                    <IconButton tabIndex={-1}>
                                        <Image src={infoMarkIcon} preview={false} />
                                    </IconButton>
                                </Tooltip>
                            }
                            {
                                customLink && <Link tabIndex={-1} to={customLink}>Go to Area</Link>
                            }
                        </Typography>
                    }
                    {
                        customLabel && <Typography variant={'subtitle1'} style={{ lineHeight: 1 }}
                            className={clsx(classes.autoCustomLabel, 'MuiInputLabel-shrink', classes.fonSize14)}>{customLabel}</Typography>
                    }
                    <TextField
                        inputRef={parentRef}
                        id={id}
                        name={`${id}${Date()}`}
                        label={customLabel ? '' : name}
                        autoComplete='one-time-code'
                        placeholder={placeholder ? placeholder : (customLabel ? customLabel : 'Please Select ' + name[0])}
                        fullWidth
                        variant={variant ? variant : 'standard'}
                        error={error ? true : false}
                        value={textValue ? textValue : ''}
                        helperText={error ? (textValue && rowsSelected ? `Selected is not Valid ${name[0]}` : error) : ''}
                        // helperText={error}
                        disabled={disabled}
                        InputProps={{
                            classes: {
                                input: clsx(classes.textFieldColor, classes.ellipse, classes.padding10r)
                            },
                            endAdornment: (
                                popupState.isOpen ? <Up tabIndex={-1} /> : <Down tabIndex={-1} />
                            ),
                        }}
                        inputProps={{
                            "aria-autocomplete": "none"
                        }}
                        InputLabelProps={{
                            className: classes.textFieldLableColorCustom,
                        }}
                        // onBlur={() => handleBlur()}
                        onKeyDown={(e) => shouldBlur(e)}
                        onChange={(e) => handleOnChange(e.target.value, notEmpty)}
                        {...bindFocus(popupState)}
                    />
                    <Popover
                        container={() => parentRef?.current && handlePopState(popupState.isOpen ? popupState.isOpen : false)}
                        {...bindPopover(popupState)}
                        // open={true}
                        anchorOrigin={{
                            vertical: position,
                            horizontal: 'left',
                        }}
                        anchorEl={parentRef?.current ?? null}
                        transformOrigin={{
                            vertical: orginPosVet ? orginPosVet : (position === 'bottom' ? 'top' : 'bottom'),
                            horizontal: orginPosHor ? orginPosHor : 'left',
                        }}
                        //transformOrigin={{ vertical: 100, horizontal: -180 }}
                        PaperProps={{
                            style: { minWidth: `${width}px`, borderRadius: 10, overFlow: "hidden" },
                        }}>
                        <FieldPrimaryCard
                            width={"auto"}
                            length={data?.length}
                            customclasses={clsx(classes.customAutoCompleteCard, { [classes.fixHeightDropDown]: data?.length > 4 }, { [classes.fixHeightDropDownPagination]: data?.length > 500 })}
                            component={
                                <PaginationTable
                                    heads={heads}
                                    width={true}
                                    rows={data ? data : []}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    changeRowsPerPage={(event) => handleChangeRowsPerPage(event)}
                                    changePage={(event, page) => handleChangePage(event, page)}
                                    clearOption={textValue ? <NavLink to={"#"} onClick={() => handleClear(popupState)} className={classes.dropClear}><img src={ResetIcon} alt={'clear'} /> <span>Reset</span></NavLink> : ''}
                                    component={
                                        <>

                                            {
                                                data && Array.isArray(data) && data?.length > 0 ?
                                                    (rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data).map((data, i) => (
                                                        <TableRow key={i} hover={true} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx({ [classes.selectedRow]: i === 0 })} data-id={data?.id} onClick={() => handleClick(data, popupState)}>
                                                            {
                                                                heads.map((d, i) => (
                                                                    <React.Fragment key={i}>
                                                                        {
                                                                            i === 0 ? (
                                                                                <TableCell title={data[d.key] ? data[d.key] : '---'} className={clsx(classes.disBlock)}><div className={classes.customeDivlength}>{join && data[join] !== '' && data[join] + ' - '}{data[d.key] ? (d.relation ? data[d.key][d.relation] : data[d.key]) : '---'} {d.subText && data[d.subText] && "(" + data[d.subText] + ")"}</div></TableCell>
                                                                            ) : (
                                                                                data[d.key] ?
                                                                                    d.relation ? <TableCell title={data[d.key][d.relation] ? data[d.key][d.relation] : '---'}>{data[d.key][d.relation] ? (data[d.key][d.relation].length > 20 ? `${data[d.key][d.relation].substring(0, 40)}...` : data[d.key][d.relation]) : '---'} {d.prefix && d.prefix}</TableCell> :
                                                                                        <TableCell title={data[d.key] ? data[d.key] : '---'}>{d.suffix && d.suffix} {data[d.key] ? (data[d.key].length > 20 ? `${data[d.key].substring(0, 20)}...` : data[d.key]) : '---'} {d.prefix && d.prefix}</TableCell>
                                                                                    : <TableCell title={`${data[d.key] === 0 ? data[d.key] : '---'} ${d.prefix && data[d.key] === 0 && d.prefix}`}>{data[d.key] === 0 ? data[d.key] : '---'} {d.prefix && data[d.key] === 0 && d.prefix}</TableCell>
                                                                            )
                                                                        }
                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                        </TableRow>
                                                    )) : (
                                                        <TableRow>
                                                            <TableCell colSpan={heads.length} style={{ textAlign: 'center', border: "none" }}>{'No result found'}</TableCell>
                                                        </TableRow>
                                                    )
                                            }
                                        </>
                                    }
                                />
                            }
                        />

                    </Popover>
                </div>
            )}
        </PopupState>
    )
}))